export enum AuthProviderEnum {
	BASIC = 'BASIC',
	GOOGLE = 'GOOGLE',
	FACEBOOK = 'FACEBOOK',
	UNKNOWN = 'UNKNOWN'
}
